/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from 'redux'
import { routerReducer } from 'Store/createStore'
import formikReducers from './formik'
import enhancersReducer from './enhancers'
import popupReducer from './popup'
import floatingReducer from './floating'
import loadingReducer from './loading'
import toastReducer from './toast'
import loginReducer from './login'
import globalReducer from './global'
import languageReducer from './language'
import userProfilingReducer from './userProfiling'
import scaReducer from './sca'
import triggerTimelineReducer from './triggerTimeline'
import chatbotReducer from './chatbot'
import shopPickerReducer from './shopPicker'
import addressReducer from './address'
import persistedActionsReducer from './persistedActions'
import routingUtilityReducer from './routingUtilityReducer'
// @generator reducers:import

export const makeRootReducer = (asyncReducers) =>
  combineReducers({
    // @generator reducers:combine
    routingUtility: routingUtilityReducer,
    persistedActions: persistedActionsReducer,
    sca: scaReducer,
    language: languageReducer,
    userProfiling: userProfilingReducer,
    global: globalReducer,
    toast: toastReducer,
    loading: loadingReducer,
    popup: popupReducer,
    floating: floatingReducer,
    enhancers: enhancersReducer,
    formik: formikReducers,
    router: routerReducer,
    login: loginReducer,
    triggerTimeline: triggerTimelineReducer,
    chatbot: chatbotReducer,
    shopPicker: shopPickerReducer,
    address: addressReducer,
    ...asyncReducers
  })

/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */

export const injectReducer = (store, { key, asyncReducer }) => {
  if (Reflect.has(store.asyncReducers, key)) return
  // Reset injected Reducers
  const costReducer = store.asyncReducers.Costs
  store.asyncReducers = {}
  if (((key === 'Transactions') && window.location.pathname.includes('costs'))) {
    store.asyncReducers.Costs = costReducer
  }
  store.asyncReducers[key] = asyncReducer
  store.replaceReducer(makeRootReducer(store.asyncReducers))
}

export default makeRootReducer
